import React, { useMemo } from 'react';

const Key = ({ colorMap }) => {
  const markers = useMemo(() => {
    return Object.entries(colorMap)
      .map(([company, markerColor]) => ({
        text: company as string,
        color: markerColor as string,
      }))
      .sort((a, b) => a.text.localeCompare(b.text));
  }, [colorMap]) as { text: string; color: string }[];

  return (
    <div className="mb-16 flex flex-col items-start gap-12">
      <div className="flex flex-col">
        <h3 className="m-0 text-headline-xs font-bold">Companies</h3>
        <div className="my-8 flex min-h-[32px] flex-wrap items-center justify-start gap-8">
          {markers.map(({ text, color }) => (
            <div key={text} className="flex items-center gap-4">
              <div className="h-10 w-10 rounded-full" style={{ backgroundColor: color }}></div>
              <p className="m-0 text-body-md">{text}</p>
            </div>
          ))}
        </div>
      </div>
      <p className="m-0 text-body-md">
        Size of the circles corresponds to the computing power at that data center
      </p>
    </div>
  );
};

export default Key;
